import React, { useCallback, useEffect, useState } from "react";
import StaffLayout from "../../components/StaffLayout";
import {
  ErrorBanner, SuccessBanner, Spinner, useEventPicker, EventSelector, Modal, fmtDate
} from "../../components/common";
import { vendorpayApi } from "../../api/vendorpayApi";
import "../../staff.css";

/**
 * /staff/vendorpay/stock — opening stock load, live adjustments, and
 * audit log of every movement.
 */
const VpStockPage = function () {
  const picker = useEventPicker();
  const _i = useState([]); const items = _i[0], setItems = _i[1];
  const _l = useState(false); const loading = _l[0], setLoading = _l[1];
  const _e = useState(""); const error = _e[0], setError = _e[1];
  const _s = useState(""); const success = _s[0], setSuccess = _s[1];
  const _f = useState({ stall_id: "", vendor_id: "", only_low: "" });
  const filters = _f[0], setFilters = _f[1];
  // Vendor + stall pickers — filled from the API so operators stop
  // typing numeric IDs.  Stall list re-fetches when the vendor or the
  // selected event changes.
  const _v = useState([]); const vendors = _v[0], setVendors = _v[1];
  const _st = useState([]); const stalls = _st[0], setStalls = _st[1];

  useEffect(function () {
    vendorpayApi.listVendors({ active: 1 })
      .then(function (r) { setVendors((r && r.vendors) || []); })
      .catch(function () { setVendors([]); });
  }, []);
  useEffect(function () {
    var params = { active: 1 };
    if (picker.selected) params.event_id = picker.selected;
    if (filters.vendor_id) params.vendor_id = filters.vendor_id;
    vendorpayApi.listStalls(params)
      .then(function (r) { setStalls((r && r.stalls) || []); })
      .catch(function () { setStalls([]); });
  }, [picker.selected, filters.vendor_id]);

  const _load = useState(null); const loadMod = _load[0], setLoadMod = _load[1];
  const _adj = useState(null); const adjMod = _adj[0], setAdjMod = _adj[1];
  const _log = useState(null); const logMod = _log[0], setLogMod = _log[1];

  const load = useCallback(function () {
    setLoading(true); setError("");
    var params = {};
    if (picker.selected) params.event_id = picker.selected;
    Object.keys(filters).forEach(function (k) { if (filters[k]) params[k] = filters[k]; });
    vendorpayApi.listStock(params).then(function (r) { setItems((r && r.inventory) || []); })
      .catch(function (e) { setError(e.message); }).then(function () { setLoading(false); });
  }, [picker.selected, filters]);
  useEffect(function () { load(); }, [load]);

  return (
    <StaffLayout>
      <h1 className="stf-page__title">VendorPay Stock</h1>
      <p className="stf-page__sub">Load opening stock, adjust mid-event, view full movement log.</p>

      <div className="stf-card" style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit,minmax(170px,1fr))", gap: 12 }}>
        <EventSelector events={picker.events} value={picker.selected} onChange={picker.setSelected} />
        <div className="stf-field" style={{ margin: 0 }}>
          <label>Vendor</label>
          <select value={filters.vendor_id} onChange={function (e) { setFilters(Object.assign({}, filters, { vendor_id: e.target.value, stall_id: "" })); }}>
            <option value="">All vendors</option>
            {vendors.map(function (v) { return <option key={v.id} value={v.id}>{v.vendor_name}</option>; })}
          </select>
        </div>
        <div className="stf-field" style={{ margin: 0 }}>
          <label>Stall</label>
          <select value={filters.stall_id} onChange={function (e) { setFilters(Object.assign({}, filters, { stall_id: e.target.value })); }}>
            <option value="">All stalls</option>
            {stalls.map(function (s) { return <option key={s.id} value={s.id}>{s.stall_name} ({s.stall_code})</option>; })}
          </select>
        </div>
        <div className="stf-field" style={{ margin: 0 }}>
          <label>Only low</label>
          <select value={filters.only_low} onChange={function (e) { setFilters(Object.assign({}, filters, { only_low: e.target.value })); }}>
            <option value="">All</option>
            <option value="1">Low stock only</option>
          </select>
        </div>
        <div className="stf-field" style={{ margin: 0 }}>
          <label>&nbsp;</label>
          <button className="stf-btn" onClick={load} disabled={loading}>{loading ? <Spinner /> : "Apply"}</button>
        </div>
      </div>

      <ErrorBanner message={error} /><SuccessBanner message={success} />

      <div style={{ display: "flex", gap: 8, marginBottom: 12 }}>
        <button className="stf-btn" onClick={function () { setLoadMod({}); }}>Load opening stock</button>
        <button className="stf-btn stf-btn--ghost" onClick={function () { setLogMod({}); }}>View movement log</button>
      </div>

      <div className="stf-card stf-card--flush">
        {items.length === 0 ? <div className="stf-empty" style={{ margin: 16 }}>No inventory rows.</div> :
          <table className="stf-table">
            <thead><tr><th>Item</th><th>Stall</th><th>Opening</th><th>Current</th><th>Reserved</th><th>Sold</th><th>Damaged</th><th>Low?</th><th></th></tr></thead>
            <tbody>
              {items.map(function (inv) {
                var low = (inv.low_stock_threshold != null) && inv.current_stock <= inv.low_stock_threshold;
                return (
                  <tr key={inv.id}>
                    <td><strong>{inv.item_name || inv.item}</strong></td>
                    <td style={{ fontSize: 12 }}>{inv.stall_name || inv.stall}</td>
                    <td>{inv.opening_stock}</td>
                    <td><strong style={{ color: low ? "#dc2626" : "#0f172a" }}>{inv.current_stock}</strong></td>
                    <td>{inv.reserved_stock || 0}</td>
                    <td>{inv.sold_quantity || 0}</td>
                    <td>{inv.damaged_quantity || 0}</td>
                    <td>{low ? "⚠️" : ""}</td>
                    <td><button className="stf-btn stf-btn--ghost stf-btn--sm" onClick={function () { setAdjMod(inv); }}>Adjust</button></td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        }
      </div>

      <LoadStockModal open={!!loadMod} onClose={function () { setLoadMod(null); }} eventId={picker.selected} onDone={function (m) { setSuccess(m); load(); }} />
      <AdjustModal open={!!adjMod} inv={adjMod} onClose={function () { setAdjMod(null); }} onDone={function (m) { setSuccess(m); load(); }} />
      <LogModal open={!!logMod} onClose={function () { setLogMod(null); }} />
    </StaffLayout>
  );
};

var LoadStockModal = function (p) {
  const _f = useState({ vendor_item_id: "", stall_id: "", opening_stock: 0, low_stock_threshold: "", notes: "" });
  const f = _f[0], setF = _f[1];
  const _b = useState(false); const busy = _b[0], setBusy = _b[1];
  const _e = useState(""); const err = _e[0], setErr = _e[1];
  // Dropdown sources — we fetch stalls + items scoped to the active
  // event so the operator doesn't have to memorise numeric IDs.
  const _st = useState([]); const stalls = _st[0], setStalls = _st[1];
  const _it = useState([]); const itemsList = _it[0], setItemsList = _it[1];

  React.useEffect(function () {
    if (p.open) {
      setF({ vendor_item_id: "", stall_id: "", opening_stock: 0, low_stock_threshold: "", notes: "" });
      setErr("");
    }
  }, [p.open]);

  React.useEffect(function () {
    if (!p.open) return;
    var params = { active: 1 };
    if (p.eventId) params.event_id = p.eventId;
    vendorpayApi.listStalls(params)
      .then(function (r) { setStalls((r && r.stalls) || []); })
      .catch(function () { setStalls([]); });
    vendorpayApi.listItems(params)
      .then(function (r) { setItemsList((r && r.items) || []); })
      .catch(function () { setItemsList([]); });
  }, [p.open, p.eventId]);

  var set = function (k) { return function (e) { setF(Object.assign({}, f, { [k]: e.target.value })); }; };
  var submit = function () {
    setBusy(true); setErr("");
    var body = {
      vendor_item_id: Number(f.vendor_item_id),
      event_id: p.eventId,
      stall_id: Number(f.stall_id),
      opening_stock: Number(f.opening_stock),
      notes: f.notes || undefined
    };
    if (f.low_stock_threshold) body.low_stock_threshold = Number(f.low_stock_threshold);
    vendorpayApi.loadStock(body).then(function () { p.onDone("Opening stock loaded"); p.onClose(); })
      .catch(function (e) { setErr(e.message); }).then(function () { setBusy(false); });
  };
  return (
    <Modal open={p.open} onClose={p.onClose} title="Load opening stock">
      <ErrorBanner message={err} />
      <div className="stf-field">
        <label>Vendor item *</label>
        <select value={f.vendor_item_id} onChange={set("vendor_item_id")}>
          <option value="">— pick item —</option>
          {itemsList.map(function (it) {
            return <option key={it.id} value={it.id}>{it.item_name} ({it.item_code})</option>;
          })}
        </select>
      </div>
      <div className="stf-field">
        <label>Stall *</label>
        <select value={f.stall_id} onChange={set("stall_id")}>
          <option value="">— pick stall —</option>
          {stalls.map(function (s) {
            return <option key={s.id} value={s.id}>{s.stall_name} ({s.stall_code})</option>;
          })}
        </select>
      </div>
      <div className="stf-field"><label>Opening stock</label><input type="number" value={f.opening_stock} onChange={set("opening_stock")} /></div>
      <div className="stf-field"><label>Low stock threshold</label><input type="number" value={f.low_stock_threshold} onChange={set("low_stock_threshold")} /></div>
      <div className="stf-field"><label>Notes</label><textarea rows={2} value={f.notes} onChange={set("notes")} /></div>
      <button className="stf-btn" disabled={busy || !p.eventId || !f.vendor_item_id || !f.stall_id} onClick={submit}>{busy ? <Spinner /> : "Load"}</button>
    </Modal>
  );
};

var AdjustModal = function (p) {
  const _f = useState({ adjustment_type: "MANUAL_ADD", quantity: 0, notes: "" });
  const f = _f[0], setF = _f[1];
  const _b = useState(false); const busy = _b[0], setBusy = _b[1];
  const _e = useState(""); const err = _e[0], setErr = _e[1];
  React.useEffect(function () { if (p.open) { setF({ adjustment_type: "MANUAL_ADD", quantity: 0, notes: "" }); setErr(""); } }, [p.open]);
  var set = function (k) { return function (e) { setF(Object.assign({}, f, { [k]: e.target.value })); }; };
  var submit = function () {
    if (!p.inv) return;
    setBusy(true); setErr("");
    vendorpayApi.adjustStock({
      inventory_id: p.inv.id,
      adjustment_type: f.adjustment_type,
      quantity: Number(f.quantity),
      notes: f.notes || undefined
    }).then(function () { p.onDone("Stock adjusted"); p.onClose(); })
      .catch(function (e) { setErr(e.message); }).then(function () { setBusy(false); });
  };
  return (
    <Modal open={p.open} onClose={p.onClose} title={"Adjust — " + (p.inv && (p.inv.item_name || p.inv.item))}>
      <ErrorBanner message={err} />
      <div className="stf-field">
        <label>Adjustment type</label>
        <select value={f.adjustment_type} onChange={set("adjustment_type")}>
          <option value="MANUAL_ADD">Manual add</option>
          <option value="MANUAL_REDUCE">Manual reduce</option>
          <option value="DAMAGE">Damage / wastage</option>
          <option value="RECONCILIATION">Reconciliation</option>
        </select>
      </div>
      <div className="stf-field"><label>Quantity</label><input type="number" value={f.quantity} onChange={set("quantity")} /></div>
      <div className="stf-field"><label>Notes</label><textarea rows={2} value={f.notes} onChange={set("notes")} /></div>
      <button className="stf-btn" disabled={busy} onClick={submit}>{busy ? <Spinner /> : "Adjust"}</button>
    </Modal>
  );
};

var LogModal = function (p) {
  const _f = useState({ inventory_id: "", adjustment_type: "" });
  const f = _f[0], setF = _f[1];
  const _r = useState([]); const rows = _r[0], setRows = _r[1];
  const _b = useState(false); const busy = _b[0], setBusy = _b[1];
  const _e = useState(""); const err = _e[0], setErr = _e[1];
  var load = function () {
    setBusy(true); setErr("");
    var params = {};
    if (f.inventory_id) params.inventory_id = f.inventory_id;
    if (f.adjustment_type) params.adjustment_type = f.adjustment_type;
    vendorpayApi.stockLog(params).then(function (r) { setRows((r && r.logs) || []); })
      .catch(function (e) { setErr(e.message); }).then(function () { setBusy(false); });
  };
  React.useEffect(function () { if (p.open) { setRows([]); load(); } }, [p.open]); // eslint-disable-line
  return (
    <Modal open={p.open} onClose={p.onClose} title="Stock movement log" maxWidth={720}>
      <ErrorBanner message={err} />
      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr auto", gap: 8, marginBottom: 10 }}>
        <div className="stf-field" style={{ margin: 0 }}><label>Inventory id</label><input value={f.inventory_id} onChange={function (e) { setF(Object.assign({}, f, { inventory_id: e.target.value })); }} /></div>
        <div className="stf-field" style={{ margin: 0 }}>
          <label>Type</label>
          <select value={f.adjustment_type} onChange={function (e) { setF(Object.assign({}, f, { adjustment_type: e.target.value })); }}>
            <option value="">All</option>
            <option value="OPENING">OPENING</option>
            <option value="SALE">SALE</option>
            <option value="CANCEL_RESTORE">CANCEL_RESTORE</option>
            <option value="DAMAGE">DAMAGE</option>
            <option value="MANUAL_ADD">MANUAL_ADD</option>
            <option value="MANUAL_REDUCE">MANUAL_REDUCE</option>
            <option value="RECONCILIATION">RECONCILIATION</option>
          </select>
        </div>
        <div className="stf-field" style={{ margin: 0 }}>
          <label>&nbsp;</label>
          <button className="stf-btn" onClick={load} disabled={busy}>{busy ? <Spinner /> : "Search"}</button>
        </div>
      </div>
      {rows.length === 0 ? <div className="stf-empty">No entries</div> :
        <table className="stf-table">
          <thead><tr><th>Time</th><th>Type</th><th>Qty</th><th>Before → After</th><th>Ref</th></tr></thead>
          <tbody>{rows.map(function (l) {
            return (
              <tr key={l.id}>
                <td style={{ fontSize: 12 }}>{fmtDate(l.created)}</td>
                <td><code>{l.adjustment_type}</code></td>
                <td>{l.quantity}</td>
                <td style={{ fontSize: 12 }}>{l.before_stock} → {l.after_stock}</td>
                <td style={{ fontSize: 11, color: "#94a3b8" }}>{(l.reference_type || "") + " " + (l.reference_id || "")}</td>
              </tr>
            );
          })}</tbody>
        </table>
      }
    </Modal>
  );
};

export default VpStockPage;
